import { useCallback, useEffect, useRef, useState } from "react";

import "./SelectComponent.scss";

import FilterIcon from "assets/images/filter-icon.svg";
import DropSelectIcon from "assets/images/drop-select-icon.svg";
import Checkbox from "common/components/Checkbox";
import { useOutsideAlerter } from "features/game/components/Pagination/CustomSelect";

interface Props {
  onCheck?: (val: any) => void;
}

const SelectComponent = ({ onCheck }: Props) => {
  const [isActive, setIsActive] = useState(false);
  const wrapperRef = useRef(null);
  const [checked, setChecked] = useState({
    ease: false,
    medium: false,
    hard: false
  });

  useOutsideAlerter(wrapperRef, () => {
    setIsActive(false);
  });

  useEffect(() => {
    const resLevels = localStorage.getItem("levels");
    if (resLevels) {
      setChecked(JSON.parse(resLevels));
    }
  }, []);

  const onCheckItem = useCallback(
    (val: any) => {
      if (val) {
        const booferChecked = {
          ...checked
        };
        if (val?.target.value === "ראשוני") {
          booferChecked.ease = val?.target?.checked;
        }
        if (val?.target.value === "בסיסי") {
          booferChecked.medium = val?.target?.checked;
        }
        if (val?.target.value === "מתקדם") {
          booferChecked.hard = val?.target?.checked;
        }

        localStorage.setItem("levels", JSON.stringify(booferChecked));

        setChecked(booferChecked);
        onCheck && onCheck(booferChecked);
      }
    },
    [checked, onCheck]
  );

  return (
    <div className="filter-otr" ref={wrapperRef}>
      <img className="filter-icon" src={FilterIcon} alt="icon" />
      <div className="dropdown">
        <div
          onClick={(e: any) => {
            setIsActive(!isActive);
          }}
          className="dropdown-btn">
          סינון לפי רמה
          <img className="drop-icon" src={DropSelectIcon} alt="icon" />
        </div>
        <div className="dropdown-content" style={{ display: isActive ? "block" : "none" }}>
          <ul
            className="RadioCheckButton-ul"
            style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            <li className="RadioCheckButton-li">
              <Checkbox label="ראשוני" onClick={onCheckItem} checked={checked?.ease} />
            </li>
            <li className="RadioCheckButton-li">
              <Checkbox label="בסיסי" onClick={onCheckItem} checked={checked?.medium} />
            </li>
            <li className="RadioCheckButton-li">
              <Checkbox label="מתקדם" onClick={onCheckItem} checked={checked?.hard} />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SelectComponent;
